module.exports = __webpack_public_path__ + "img/icon_10.92b417d3.png";